export const STAFF_PERMS = [
  ["listings", "Pritje & Publikime"], ["verifications", "Verifikime"], ["reports", "Raporte"], ["users", "Përdorues"],
  ["posts", "Biseda"], ["categories", "Kategori"], ["places", "Shtete"], ["settings", "Footer, Kreu, Reklama, Rregullat, Fjalë të ndaluara"],
  ["stats", "Statistikat & Rrjete sociale"], ["bizimport", "Gjej biznes"], ["trash", "Koshi"],
];

export const isAdminLike = (u) => !!u && (u.role === "admin" || u.role === "staff");
export const can = (u, p) => !!u && (u.role === "admin" || (p !== "points" && u.role === "staff" && (p === "any" || (u.perms || []).includes(p))));
